/*
[GNU Affero General Public License (AGPL)](https://www.gnu.org/licenses/agpl-3.0.html)

VeloceSupabase - A library for working with supabase made in Angular v17+ made with care by Colibryx Srl in Italy.
Copyright (C) 2025 Colibryx S.r.l.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

This license applies to any accompanying files located directly in the same directory.
*/

import { Injectable, inject } from "@angular/core";
import { LoggerService } from "./logger.service";
import { ToastService } from "@app/widgets/base/notification/toast.service";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
	providedIn: "root",
})
export class ErrorHandlerService {
	private readonly loggerService: LoggerService = inject(LoggerService);
	private readonly toastService: ToastService = inject(ToastService);
	private readonly translateService: TranslateService =
		inject(TranslateService);

	public handleError(error: any, showDefaultToast: boolean): void {
		// Here you could add error logging or reporting to an external service
		this.loggerService.logError(
			"ErrorHandlerService: An error occurred:",
			error,
		);
		if (showDefaultToast) {
			this.toastService.showError(
				error?.message
					? this.translateService.instant(error.message)
					: error
						? error
						: JSON.stringify(error),
			);
		}
		// Possibly rethrow the error or format it for user consumption
		throw error; // Or customize the thrown error based on the context
	}
}
